// import logo from './logo.svg';
import React from "react";
//theme
import "primereact/resources/themes/lara-light-indigo/theme.css";
// [NUEVO] Importar overrides de tema centralizados
/* import "./styles/theme-overrides.css"; */

//core
import "primereact/resources/primereact.min.css";
import "primeflex/primeflex.css";

// Fix para calendario transparente
import "./styles/calendar-fix.css";

import {
  Cotizador,
  // Landing, // vista vieja — se conserva hasta validar Landing2 (plan-landing-rediseno.md)
  NotFound,
  GenerateBudgetPDF,
  NoticePrivacy,
  UserDashboardView,
} from "./Views";
/* import { CotizadorTest } from "./Views/CotizadorTest/CotizadorTest";*/
import { Test } from "./Views/Test";
import { prod, sourceTrimAccessEnabled, sourceTrimRoute } from "./env";
import { Navigate, Route, Routes } from "react-router-dom";
import TermsAndConditions from "./Views/termsAndConditions/TermsAndConditions";
import Landing2 from "./Views/Landing2";
import { AuthProvider } from "./Context/AuthContext";
import { Login } from "./Views/Login/Login";
import { AdminShell } from "./Views/Admin/shell/AdminShell";
import { DashboardPage } from "./Views/Admin/pages/DashboardPage";
import { CotizacionesPage } from "./Views/Admin/pages/CotizacionesPage";
import { UsuariosPage } from "./Views/Admin/pages/UsuariosPage";
import { GestionUsuariosPage } from "./Views/Admin/pages/GestionUsuariosPage";
import { ValoresResidualesPage } from "./Views/Admin/pages/ValoresResidualesPage";
import { ParametrosGestoriaPage } from "./Views/Admin/pages/ParametrosGestoriaPage";
import { DireccionPlacasPage } from "./Views/Admin/pages/DireccionPlacasPage";
import { ContrasenaPage } from "./Views/Admin/pages/ContrasenaPage";
import { ClaveCotizadorPage } from "./Views/Admin/pages/ClaveCotizadorPage";
import { VencimientosPage } from "./Views/Admin/pages/VencimientosPage";
import { CarteraPage } from "./Views/Admin/pages/CarteraPage";
import { BuroPage } from "./Views/Admin/pages/BuroPage";
import { TasasFinancierasPage } from "./Views/Admin/pages/TasasFinancierasPage";
import { TrimAdminShell } from "./Views/AdminTrim/TrimAdminShell";
import { TrimDashboardPage } from "./Views/AdminTrim/pages/TrimDashboardPage";
import { TrimGestionUsuariosPage } from "./Views/AdminTrim/pages/TrimGestionUsuariosPage";
import { VendedorShell } from "./Views/Vendedor/VendedorShell";
import { VendedorDashboardPage } from "./Views/Vendedor/pages/VendedorDashboardPage";
import { ResetPassword } from "./Views/ResetPassword/ResetPassword";
import WhatsAppButton from "./Components/WhatsAppButton/WhatsAppButton";
import Share from "./Views/Cotizador/Share/Share";
import PDFPreview from "./Views/Cotizador/PDFComponent/PDFPreview";
import SourceTrimAccessGate from "./Views/Cotizador/SourceTrimAccessGate";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Routes>
          {/* Rediseño F1 (plan-landing-rediseno.md): Landing2 sustituye a Landing.
              La vista vieja se conserva en Views/Landing hasta validar. */}
          <Route path="/" element={<Landing2 />} />
          <Route path="/:section" element={<Landing2 />} />

          <Route path="/cotizar/:" element={<Cotizador />} />
          <Route path="/cotizar/:status" element={<Cotizador />} />
          <Route path="/cotizar/secret/:secret" element={<Cotizador />} />
          {sourceTrimAccessEnabled ? <Route path={sourceTrimRoute} element={<SourceTrimAccessGate />} /> : null}
          {/* <Route path="/cotizar/share/:secret" element={<Cotizador />} /> */}
          <Route path="/cotizar/share/:secret" element={<Share />} />

          <Route path="/aviso-de-privacidad" element={<NoticePrivacy />} />

          <Route
            path="/terminos-condiciones"
            element={<TermsAndConditions />}
          />

          <Route path="/descargar/:secret" element={<GenerateBudgetPDF />} />

          {/* {prod ? null : <Route path="/test" element={<Test />} />} */}
          {prod ? null : <Route path="/pdf-preview" element={<PDFPreview />} />}
          {/*  {prod ? null : <Route path="/cotizar-test" element={<CotizadorTest />} />} */}
          <Route path="/login" element={<Login isRegistered={null} setStep={null} />} />

          <Route path="/admin" element={<AdminShell />}>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="cotizaciones" element={<CotizacionesPage />} />
            <Route path="usuarios" element={<UsuariosPage />} />
            <Route path="gestion-usuarios" element={<GestionUsuariosPage />} />
            <Route path="vencimientos" element={<VencimientosPage />} />
            <Route path="cartera" element={<CarteraPage />} />
            <Route path="buro" element={<BuroPage />} />
            <Route path="valores-residuales" element={<ValoresResidualesPage />} />
            <Route path="tasas-financieras" element={<TasasFinancierasPage />} />
            <Route path="parametros-gestoria" element={<ParametrosGestoriaPage />} />
            <Route path="direccion-placas" element={<DireccionPlacasPage />} />
            <Route path="contrasena" element={<ContrasenaPage />} />
            <Route path="clave-cotizador" element={<ClaveCotizadorPage />} />
          </Route>
          <Route path="/admin-trim" element={<TrimAdminShell />}>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<TrimDashboardPage />} />
            <Route path="gestion-usuarios" element={<TrimGestionUsuariosPage />} />
          </Route>
          <Route path="/vendedor" element={<VendedorShell />}>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<VendedorDashboardPage />} />
          </Route>
          <Route path="/mi-dashboard" element={<UserDashboardView />} />

          <Route path="/recuperar-contrasena" element={<ResetPassword />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
        <WhatsAppButton />
      </AuthProvider>
    </div>
  );
}

export default App;
